<template>
  <div class="card">
    <div v-if="title" class="card-header">
      {{ prefix }}<span :style="cardHeader">{{ title }}</span>
      <span v-if="by" class="card-by">
        {{ by }}
        <span v-if="name" class="card-name" :style="cardName">
          {{ name }}
        </span>
      </span>
    </div>

    <div class="card-body">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Card',

  data: () => ({
    cardHeader: "",
    cardName: ""
  }),

  props: {
    prefix: { type: String, default: null },
    title: { type: String, default: null },
    by: { type: String, default: null },
    name: { type: String, default: null },
    color: { type: String, default: null },
    furnicolor: { type: String, default: null }
  },

  watch: { 
    furnicolor: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal) {
          this.cardHeader = "color: "+ newVal +"; text-shadow: 2px 0px 11px "+ newVal;
        }
        else {
          this.cardHeader = "";
        }
      }
    },
    color: {
      immediate: true,
      handler(newVal, oldVal) {
        if(newVal) {
          this.cardName = "color: "+ newVal +"; text-shadow: 2px 0px 11px "+ newVal;
        }
        else {
          this.cardName = "";
        }
      }
    }
  }
}
</script>

<style>
.card-by {
  float: right;
  color: #808080;
  text-shadow: none;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/Card.vue